<template>
    <svg
        width="43"
        height="39"
        viewBox="0 0 43 39"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_ii_1282_1418)">
            <path
                d="M33.642 23.0901C34.2398 24.5646 33.7273 26.2563 32.4119 27.1513L29.0742 29.4222C24.2969 32.6726 18.0183 32.6725 13.2411 29.422L9.90394 27.1514C8.58852 26.2563 8.07613 24.5646 8.67385 23.0901L12.2962 14.1543C13.3296 11.605 15.8056 9.93697 18.5564 9.93697L23.7595 9.93697C26.5103 9.93697 28.9863 11.605 30.0197 14.1543L33.642 23.0901Z"
                fill="url(#paint0_linear_1282_1418)"
            />
        </g>
        <foreignObject
            x="4.00543e-05"
            y="-0.0007689"
            width="42.3161"
            height="38.6571"
            ><div
                xmlns="http://www.w3.org/1999/xhtml"
                style="
                    backdrop-filter: blur(0.95px);
                    clip-path: url(#bgblur_0_1282_1418_clip_path);
                    height: 100%;
                    width: 100%;
                "
            ></div
        ></foreignObject>
        <g
            filter="url(#filter1_ddii_1282_1418)"
            data-figma-bg-blur-radius="1.89729"
        >
            <path
                d="M8.67389 13.9178C8.07616 12.4432 8.58859 10.7515 9.90405 9.85647L12.925 7.80103C17.8934 4.42063 24.4232 4.42071 29.3915 7.80124L32.412 9.85645C33.7274 10.7515 34.2398 12.4432 33.6421 13.9177L30.0197 22.8535C28.9863 25.4028 26.5103 27.0708 23.7595 27.0708H18.5564C15.8056 27.0708 13.3296 25.4028 12.2962 22.8535L8.67389 13.9178Z"
                fill="url(#paint1_radial_1282_1418)"
                shape-rendering="crispEdges"
            />
        </g>
        <foreignObject x="16.2939" y="10.9221" width="10.5823" height="13.5757"
            ><div
                xmlns="http://www.w3.org/1999/xhtml"
                style="
                    backdrop-filter: blur(0.31px);
                    clip-path: url(#bgblur_1_1282_1418_clip_path);
                    height: 100%;
                    width: 100%;
                "
            ></div
        ></foreignObject>
        <g
            filter="url(#filter2_ii_1282_1418)"
            data-figma-bg-blur-radius="0.618893"
        >
            <path
                d="M21.5685 23.8793C20.1053 23.8793 18.9746 23.5468 18.1765 22.8817C17.3895 22.2055 16.9683 21.2965 16.9129 20.1548L19.4901 20.055C19.5455 20.6425 19.7561 21.0748 20.1219 21.352C20.4877 21.618 20.9699 21.751 21.5685 21.751C22.156 21.751 22.6493 21.618 23.0483 21.352C23.4474 21.0748 23.6469 20.6647 23.6469 20.1215C23.6469 19.5562 23.4529 19.135 23.065 18.8579C22.677 18.5697 22.1505 18.4256 21.4854 18.4256H20.4378V16.5467H21.4854C21.9953 16.5467 22.4165 16.4414 22.749 16.2308C23.0927 16.0091 23.2645 15.6377 23.2645 15.1167C23.2645 14.6733 23.1259 14.3242 22.8488 14.0692C22.5717 13.8032 22.1338 13.6702 21.5352 13.6702C20.9367 13.6702 20.4877 13.7921 20.1884 14.036C19.8891 14.2798 19.7062 14.5957 19.6397 14.9837L17.0958 14.8507C17.2066 13.8531 17.6445 13.0549 18.4093 12.4564C19.1853 11.8467 20.2272 11.5419 21.5352 11.5419C22.9319 11.5419 24.0016 11.8412 24.7443 12.4397C25.487 13.0272 25.8583 13.8309 25.8583 14.8507C25.8583 15.4604 25.681 15.9814 25.3263 16.4137C24.9826 16.8349 24.4783 17.1508 23.8132 17.3614C24.5891 17.572 25.1877 17.9323 25.6089 18.4422C26.0412 18.941 26.2574 19.5618 26.2574 20.3044C26.2574 21.0471 26.0634 21.6901 25.6754 22.2332C25.2875 22.7653 24.7443 23.1754 24.046 23.4636C23.3476 23.7408 22.5218 23.8793 21.5685 23.8793Z"
                fill="url(#paint2_linear_1282_1418)"
                fill-opacity="0.9"
            />
        </g>
        <defs>
            <filter
                id="filter0_ii_1282_1418"
                x="8.42603"
                y="9.9375"
                width="25.6713"
                height="22.0903"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="0.168411" />
                <feGaussianBlur stdDeviation="0.682746" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1282_1418"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.20769" dy="0.103845" />
                <feGaussianBlur stdDeviation="0.113791" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_1282_1418"
                    result="effect2_innerShadow_1282_1418"
                />
            </filter>
            <filter
                id="filter1_ddii_1282_1418"
                x="4.00543e-05"
                y="-0.0007689"
                width="42.3161"
                height="38.6571"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="3.15984" />
                <feGaussianBlur stdDeviation="4.21311" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0483312 0 0 0 0 0.0581742 0 0 0 0 0.245192 0 0 0 0.33 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_1282_1418"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="1.89729" />
                <feGaussianBlur stdDeviation="0.948644" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.0566522 0 0 0 0 0.0916705 0 0 0 0 0.206731 0 0 0 0.25 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow_1282_1418"
                    result="effect2_dropShadow_1282_1418"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow_1282_1418"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.101982" dy="0.101982" />
                <feGaussianBlur stdDeviation="0.0732943" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.62 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect3_innerShadow_1282_1418"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.26188" dy="0.26188" />
                <feGaussianBlur stdDeviation="1.3094" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect3_innerShadow_1282_1418"
                    result="effect4_innerShadow_1282_1418"
                />
            </filter>
            <clipPath
                id="bgblur_0_1282_1418_clip_path"
                transform="translate(-4.00543e-05 0.0007689)"
            >
                <path
                    d="M8.67389 13.9178C8.07616 12.4432 8.58859 10.7515 9.90405 9.85647L12.925 7.80103C17.8934 4.42063 24.4232 4.42071 29.3915 7.80124L32.412 9.85645C33.7274 10.7515 34.2398 12.4432 33.6421 13.9177L30.0197 22.8535C28.9863 25.4028 26.5103 27.0708 23.7595 27.0708H18.5564C15.8056 27.0708 13.3296 25.4028 12.2962 22.8535L8.67389 13.9178Z"
                />
            </clipPath>
            <filter
                id="filter2_ii_1282_1418"
                x="16.2939"
                y="10.9221"
                width="10.5823"
                height="13.5757"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.0076732" dy="0.691235" />
                <feGaussianBlur stdDeviation="0.24687" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.00134747 0 0 0 0 0.00134747 0 0 0 0 0.00134747 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1282_1418"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.0617174" dy="0.0617174" />
                <feGaussianBlur stdDeviation="0.00925761" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.62 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_1282_1418"
                    result="effect2_innerShadow_1282_1418"
                />
            </filter>
            <clipPath
                id="bgblur_1_1282_1418_clip_path"
                transform="translate(-16.2939 -10.9221)"
            >
                <path
                    d="M21.5685 23.8793C20.1053 23.8793 18.9746 23.5468 18.1765 22.8817C17.3895 22.2055 16.9683 21.2965 16.9129 20.1548L19.4901 20.055C19.5455 20.6425 19.7561 21.0748 20.1219 21.352C20.4877 21.618 20.9699 21.751 21.5685 21.751C22.156 21.751 22.6493 21.618 23.0483 21.352C23.4474 21.0748 23.6469 20.6647 23.6469 20.1215C23.6469 19.5562 23.4529 19.135 23.065 18.8579C22.677 18.5697 22.1505 18.4256 21.4854 18.4256H20.4378V16.5467H21.4854C21.9953 16.5467 22.4165 16.4414 22.749 16.2308C23.0927 16.0091 23.2645 15.6377 23.2645 15.1167C23.2645 14.6733 23.1259 14.3242 22.8488 14.0692C22.5717 13.8032 22.1338 13.6702 21.5352 13.6702C20.9367 13.6702 20.4877 13.7921 20.1884 14.036C19.8891 14.2798 19.7062 14.5957 19.6397 14.9837L17.0958 14.8507C17.2066 13.8531 17.6445 13.0549 18.4093 12.4564C19.1853 11.8467 20.2272 11.5419 21.5352 11.5419C22.9319 11.5419 24.0016 11.8412 24.7443 12.4397C25.487 13.0272 25.8583 13.8309 25.8583 14.8507C25.8583 15.4604 25.681 15.9814 25.3263 16.4137C24.9826 16.8349 24.4783 17.1508 23.8132 17.3614C24.5891 17.572 25.1877 17.9323 25.6089 18.4422C26.0412 18.941 26.2574 19.5618 26.2574 20.3044C26.2574 21.0471 26.0634 21.6901 25.6754 22.2332C25.2875 22.7653 24.7443 23.1754 24.046 23.4636C23.3476 23.7408 22.5218 23.8793 21.5685 23.8793Z"
                />
            </clipPath>
            <linearGradient
                id="paint0_linear_1282_1418"
                x1="34.6665"
                y1="8.59724"
                x2="4.73754"
                y2="22.0184"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#FF92BA" />
                <stop offset="0.619007" stop-color="#E02E70" />
                <stop offset="1" stop-color="#590054" />
            </linearGradient>
            <radialGradient
                id="paint1_radial_1282_1418"
                cx="0"
                cy="0"
                r="1"
                gradientTransform="matrix(-23.9509 32.8569 -31.1249 -25.1589 38.4015 14.635)"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#E63274" stop-opacity="0" />
                <stop offset="1" stop-color="#E23876" />
            </radialGradient>
            <linearGradient
                id="paint2_linear_1282_1418"
                x1="16.0884"
                y1="13.9569"
                x2="6.59115"
                y2="28.8942"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="white" />
                <stop offset="0.487861" stop-color="#B7B7B7" />
                <stop offset="1" stop-color="#707070" />
            </linearGradient>
        </defs>
    </svg>
</template>
